<section class="vm-hero {{ class }}">
  <header class="vm-hero__header">
    <img class="vm-hero__logo" [src]="logoSrc" alt="Virgin Mobile" />
    <div class="vm-hero__text" *ngIf="title || subtitle">
      <h1 class="vm-hero__title" *ngIf="title">{{ title }}</h1>
      <p class="vm-hero__subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <div class="vm-hero__media">
      <img
        class="vm-hero__img vm-hero__img--mobile"
        [src]="mobileImageSrc"
        alt=""
      />
      <img
        class="vm-hero__img vm-hero__img--desktop"
        [src]="desktopImageSrc"
        alt=""
      />
    </div>
  </header>

  <div class="vm-card__content">
    <ng-content></ng-content>
  </div>
  <div class="polygon" *ngIf="showFooter"></div>
</section>
